import { useLayoutEffect, useRef, type ReactNode } from 'react'
import { X } from 'lucide-react'

export function WorkspaceDialog({
  title,
  eyebrow,
  onClose,
  children,
  className = '',
  initialFocus = 'field',
}: {
  title: string
  eyebrow: string
  onClose: () => void
  children: ReactNode
  className?: string
  initialFocus?: 'field' | 'close'
}) {
  const ref = useRef<HTMLDialogElement>(null)
  useLayoutEffect(() => {
    const previous = document.activeElement as HTMLElement | null
    ref.current?.showModal()
    ref.current
      ?.querySelector<HTMLElement>(
        initialFocus === 'close'
          ? '.workspace-dialog-header button'
          : 'input, select',
      )
      ?.focus({ preventScroll: true })
    return () => previous?.focus()
  }, [])
  return (
    <dialog
      ref={ref}
      className={'workspace-dialog ' + className}
      aria-label={title}
      onCancel={(event) => {
        event.preventDefault()
        onClose()
      }}
    >
      <header className="workspace-dialog-header">
        <div>
          <span className="eyebrow">{eyebrow}</span>
          <h2>{title}</h2>
        </div>
        <button
          type="button"
          className="icon-button"
          aria-label={'Close ' + title.toLowerCase()}
          onClick={onClose}
        >
          <X size={20} />
        </button>
      </header>
      {children}
    </dialog>
  )
}
